// extracted by mini-css-extract-plugin
export var divider = "_qu-0";
export var systemMessage = "_qu-1";